module.exports = {
  resolutions: {
    1080: false,
    720: false,
    480: true,
    360: false,
  },
  keyCdn: {
    active: false,
    url: 'omb-11bc8.kxcdn.com',
  },
  server: {
    data: '/',
    frontend: '/',
    thumb: '/',
    video: '/',
    asset: '/',
    sub: '/',
    file: '/',
    sound: '/'
  }
}


// WEBPACK FOOTER //
// ./src/config.js